import { useEffect, useState } from 'react';
import { AppShell } from '../../components/AppShell';
import { ReferralRow } from '../../components/ReferralRow';
import { Spinner } from '../../components/Spinner';
import { apiGet, ClientApiError } from '../../api/client';
import { useAuth } from '../../auth/AuthContext';
import type { Referral } from '../../../shared/types';

export function JobListScreen() {
  const { user } = useAuth();
  const [referrals, setReferrals] = useState<Referral[] | null>(null);
  const [error, setError] = useState('');
  const [showDone, setShowDone] = useState(false);

  useEffect(() => {
    apiGet<{ referrals: Referral[] }>('/api/referrals')
      .then((data) => setReferrals(data.referrals))
      .catch((caught) =>
        setError(caught instanceof ClientApiError ? caught.message : 'Could not load your jobs.'),
      );
  }, []);

  const open = referrals?.filter((r) => r.status !== 'complete' && r.status !== 'declined') ?? [];
  const done = referrals?.filter((r) => r.status === 'complete' || r.status === 'declined') ?? [];
  const visible = showDone ? done : open;

  return (
    <AppShell title={user?.role === 'recon' ? 'Recon Jobs' : 'My Jobs'}>
      <div className="row" style={{ marginBottom: '0.75rem' }}>
        {[
          { key: false, label: `Open (${open.length})` },
          { key: true, label: `Closed (${done.length})` },
        ].map((tab) => (
          <button
            key={String(tab.key)}
            type="button"
            onClick={() => setShowDone(tab.key)}
            style={{
              minHeight: 'var(--tap)',
              padding: '0 0.9rem',
              borderRadius: 999,
              border: '1px solid var(--line)',
              background: showDone === tab.key ? 'var(--navy)' : 'var(--surface)',
              color: showDone === tab.key ? '#fff' : 'var(--muted)',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {error && <div className="error-banner">{error}</div>}
      {!referrals && !error && <Spinner label="Loading your jobs" />}
      {referrals && visible.length === 0 && (
        <p className="muted">{showDone ? 'Nothing closed yet.' : 'No open jobs right now.'}</p>
      )}
      {visible.map((referral) => (
        <ReferralRow key={referral.id} referral={referral} to={`/jobs/${referral.id}`} />
      ))}
    </AppShell>
  );
}
